import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption, ButtonBar, ScreenHeader
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOALivingTrust() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ livingTrust, setLivingTrust ] = useState(powerOfAttorney.living_trust_transfers || false);
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../estate-trust');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      living_trust_transfers: livingTrust
    }));
    navigate('../legal-actions');
  }, [ livingTrust, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-living-trust screen-container screen">
      <ScreenHeader
        title="Transferring Property to Your Living Trust"
        description="Decide whether to allow your agent to transfer property to your living trust"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Are Living Trust Transfer Powers?</h3>
        <p>
          Living trust transfer powers allow your agent to move your assets into your 
          existing living trust. This includes:
        </p>
        <ul className="living-trust-list">
          <li>Transferring real estate to the trust</li>
          <li>Moving bank accounts and investments</li>
          <li>Retitling personal property</li>
          <li>Updating beneficiary designations</li>
          <li>Coordinating with trust documents</li>
          <li>Handling trust funding requirements</li>
        </ul>

        <h3>What Your Agent Can Do</h3>
        <p>If you grant this power, your agent can:</p>
        <ul className="agent-powers">
          <li>Transfer assets into your living trust</li>
          <li>Change titles and ownership documents</li>
          <li>Work with financial institutions</li>
          <li>Update account registrations</li>
          <li>Coordinate with your estate planning attorney</li>
          <li>Ensure proper trust funding</li>
        </ul>

        <h3>Do You Want to Grant This Power?</h3>
        <div className="asset-distribution-option-container">
          <AssetDistributionOption
            id="living-trust-yes"
            label="Yes"
            description="Allow transfers to my living trust"
            value="yes"
          />
          <AssetDistributionOption
            id="living-trust-no"
            label="No"
            description="Do not allow transfers to my living trust"
            value="no"
          />
        </div>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            This power only applies if you already have a living trust. Your agent cannot 
            create a new trust for you, only transfer assets to an existing trust according 
            to your estate plan.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
